<div class="analytics-page-component">
  @if (showDashboard) {
    <div class="dashboard">
      <div class="d-flex justify-content-between">
        <h2>Order Projection Dashboard</h2>
      </div>
      <app-report
        [url]="dashboardUrl"
        [token]="userToken$ | async"
        [height]="dashboardHeight"
      >
      </app-report>
    </div>
  }
  @if (!showDashboard) {
    <app-unauthorized-page></app-unauthorized-page>
  }
</div>
